import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './subscription-success.html';

@Component({
  controllerAs: 'subscriptionSuccess',
  template
})

export default class SubscriptionSuccess {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    '$stateParams',
    'toaster',
    'authService',
    'spinnerService',
    '$q',
    'orderService',
    '$timeout',
    '$window','$state','APP'
   
  ];

  constructor($scope, $ngRedux, $state, $stateParams, toaster, $auth, $spinner, $q, $order, $timeout,
    $window, APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$stateParams = $stateParams;
    this.$order = $order;
    this.toaster = toaster;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
   this.$window = $window;
    this.$auth = $auth;
    this.$state = $state;
    this.APP = APP;
    this.dscMasterCode = '88888888'; // Named constant
    this.isCardSaved = $stateParams.isCardSaved;
    let orderSummaryPromise = $order.getSubscriptionsDetail($stateParams.subscriptionId)
     .catch(() => {} // console.log("djsfskfd")
    );
    /* $state.go('payment.failure')*/

    let userProfilePromise = $auth.getUserProfile();

    $spinner.show('appSpinner');
    let promises = [orderSummaryPromise, userProfilePromise];
    $q.all(promises).finally(() => $spinner.hide('appSpinner'));

    localStorage.removeItem('deliveryAddress');
    this.currencyType = 'USD';
    $timeout(() => {
    this.country = this.profile.store.country.countryCode?this.profile.store.country.countryCode:'US';
    
      if(this.profile.store){
        // console.log(this.profile);
        this.currencyType=$order.getCurrencyType(this.country);
      }
    },800);
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      summary:state.order.subscriptionsDetail,
      userShippingZone: state.order.userShippingZone
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  formattedTime(dateTime) {
    const date = dateTime ? new Date(dateTime) : new Date();
    const hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
    let time = (hours < 10 ? `0${hours}` : hours) + ':' +
      (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes());
    const ampm = date.getHours() >= 12 ? ' PM' : ' AM';
    return time + ampm;
  }

  saveCardDetail() {
    this.$order.saveCardDetail(this.$stateParams.subscriptionId)
      .then(success => this.toaster.pop('success', success.data.message));
  }

  getDSCDiscount() {
    if (this.profile.customer && (this.profile.customer.dscId === 'C' &&
      new Date() <= new Date(this.profile.customer.dscExpireDate))) {
      let dscItems = this.summary.orderEntries &&
      this.summary.orderEntries.filter(item => item.item.subCategory.category.dscCategory);
      let totalPrice = dscItems && dscItems.map(item => item.item.price * item.quantity)
        .reduce((prev, curr) => prev + curr, 0);
      return totalPrice * 15 / 100;
    }
    return 0;
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }
  getSelectedShipmentCharge() {
    if (this.userShippingZone) {
      return this.userShippingZone.nextDayCharge;
    }
    return 0;
  }
  getSubtotal() {

    let totalPrice = 0;
    if (( this.isDscMember() || this.cartContainsDsc()) && this.summary.subscriptionCart) {
      let dscItems = this.summary.subscriptionCart.filter(item => item.item.subCategory.category.dscCategory);
      let dscTotal = dscItems.map(item => (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity)
    .reduce((prev, curr) => prev + curr, 0);
      let nondscItems = this.summary.subscriptionCart.filter(item => !item.item.subCategory.category.dscCategory);
      let nonDscTotal = nondscItems.map(item => item.item.price * item.quantity)
    .reduce((prev, curr) => prev + curr, 0);
      totalPrice = dscTotal + nonDscTotal;
    }
    else {
      totalPrice = this.totalRetailPrice();
    }
    // console.log("Hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
    // console.log(totalPrice);
    return totalPrice;
  }
  totalRetailPrice() {
    return this.summary.subscriptionCart.map(item => item.item.price * item.quantity)
  .reduce((prev, curr) => prev + curr);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  calculateTotalWeight() {
    if (this.summary.subscriptionCart){
    var weightsArray = this.summary.subscriptionCart.map(totalWeight => totalWeight.quantity * totalWeight.item.weight);
    let totalWeight = 0;
    for (var i = 0; i < weightsArray.length; i++) {
      totalWeight += weightsArray[i];

    }
    return totalWeight; }
    return "";
  }

  calculateTotalProductWeight(quantity, weight) {
    return quantity * weight;
  }

  cartContainsOnlyDsc() {
    const dscIsInCart = (this.summary.subscriptionCart.filter(item => item.item.masterProduct.masterCode === this.dscMasterCode)).length;
    const totalItemsInCart = this.summary.subscriptionCart.length;
    return dscIsInCart && (totalItemsInCart === dscIsInCart);
  }

}



// WEBPACK FOOTER //
// ./src/app/order/subscription-detail/subscription-success.js